import { ChainId } from '@nominex/nomiswap-sdk'
import sample from 'lodash-es/sample'

const NODES: Record<ChainId, { default: string; public: string[] }> = {
  [ChainId.BSC]: {
    default: 'https://bsc-dataseed1.binance.org',
    public: [
      'https://bsc-dataseed1.binance.org',
      'https://bsc-dataseed1.defibit.io',
      'https://bsc-dataseed1.ninicoin.io',
    ],
  },
  [ChainId.ETHEREUM]: {
    default: 'https://eth.llamarpc.com',
    public: ['https://eth.llamarpc.com', 'https://rpc.ankr.com/eth'],
  },
  [ChainId.MATIC]: {
    default: 'https://polygon-rpc.com',
    public: ['https://polygon-rpc.com', 'https://rpc.ankr.com/polygon'],
  },
  [ChainId.OPTIMISM]: {
    default: 'https://opt-mainnet.g.alchemy.com/v2/demo',
    public: [
      'https://mainnet.optimism.io',
      'https://endpoints.omniatech.io/v1/op/mainnet/public',
      'https://opt-mainnet.g.alchemy.com/v2/demo',
      'https://1rpc.io/op',
    ],
  },
  [ChainId.GNOSIS]: {
    default: 'https://rpc.gnosischain.com',
    public: ['https://rpc.gnosischain.com'],
  },
  [ChainId.ARBITRUM]: {
    default: 'https://arb1.arbitrum.io/rpc',
    public: ['https://arb1.arbitrum.io/rpc'],
  },
  [ChainId.AVALANCHE]: {
    default: 'https://api.avax.network/ext/bc/C/rpc',
    public: ['https://api.avax.network/ext/bc/C/rpc'],
  },
}

const getDefaultNodeUrl = (chainId: ChainId) => NODES[chainId].default

const getNodeUrl = (chainId: ChainId) => sample(NODES[chainId].public)

export { getDefaultNodeUrl, getNodeUrl }
